/**
 * A megadott `array`-t egy szinttel flatten-eli.
 * @template T
 * @param {ArrayLike<T | readonly T[]>} array - A megadott tömb.
 * @returns {T[]} A lapos lista.
 */
module.exports.flatten = function flatten (array) {
  return Array.from(array).reduce((/** @type {T[]} */ acc, curr) => acc.concat(curr), [])
}
